import { styled } from '../../utils/styled'

export const StyledPromoBannerContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'backgroundGradient'
})<{ backgroundGradient: string }>(({ backgroundGradient, theme }) => ({
  borderRadius: theme.borderRadius.xxLarge,
  background: backgroundGradient,
  width: '100%',
  minWidth: '200px',
  position: 'relative',
  overflow: 'hidden',
  padding: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
}))

export const StyledTagContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(4),
  right: theme.spacing(4),
  zIndex: 2
}))

export const StyledContentContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSmall'
})<{ isSmall: boolean }>(({ isSmall, theme }) => ({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(4),
  width: isSmall ? '100%' : 'auto',
  maxWidth: isSmall ? '100%' : '60%',
  minWidth: 0,
  marginRight: isSmall ? 0 : theme.spacing(5)
}))

export const StyledHeadline = styled('div')(({ theme }) => ({
  fontWeight: 600,
  color: theme.tokens.foreground.main.primary,
  '& .MuiTypography-root': {
    color: 'inherit'
  }
}))

export const StyledContentText = styled('div')(({ theme }) => ({
  color: theme.tokens.foreground.main.primary,
  '& .MuiTypography-root': {
    color: 'inherit'
  }
}))

export const StyledButtonsContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'buttonDirection' && prop !== 'buttonsFullWidth'
})<{ buttonDirection: 'row' | 'column'; buttonsFullWidth: boolean }>(({ buttonDirection, buttonsFullWidth }) => ({
  display: 'flex',
  flexDirection: buttonDirection,
  gap: '8px',
  width: buttonsFullWidth ? '100%' : 'auto',
  flexShrink: 0
}))

export const StyledLearnMoreButtonWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'buttonsFullWidth'
})<{ buttonsFullWidth: boolean }>(({ buttonsFullWidth }) => ({
  width: buttonsFullWidth ? '100%' : 'auto',
  '& button': {
    width: '100%'
  }
}))

export const StyledDismissButtonWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'buttonsFullWidth'
})<{ buttonsFullWidth: boolean }>(({ buttonsFullWidth }) => ({
  width: buttonsFullWidth ? '100%' : 'auto',
  '& button': {
    width: '100%'
  }
}))

export const StyledImageContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSmall'
})<{ isSmall: boolean }>(({ isSmall, theme }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  bottom: 0,
  left: isSmall ? '100%' : 'calc(60% + 20px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  zIndex: 0,
  pointerEvents: 'none',
  overflow: 'hidden',
  borderRadius: theme.borderRadius.xxLarge,
  minWidth: 0
}))

export const StyledImage = styled('img')({
  width: 'auto',
  height: '100%',
  objectFit: 'contain'
})
